import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from "@/config";
import { pests } from "@/api/api_url";
import { getToken, formatYMD } from "@/libs/util";
import { renderFormMixins } from "@/mixins/renderFormMixins";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmCityList from "vue-baidu-map/components/controls/CityList.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import { area_list, get_merchant_all, allocation_add } from "@/api/jingxiaoshang";
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      merchantData: [],
      areaData: [],
      country_code: "",
      headers: {
        Authorization: getToken()
      },
      formModel: {
        dids: null,
        //did
        merchant_code: null,
        filename: null
      },
      formRules: {
        // area_codes:[{required: true,type:'array', message: '出货区域不能为空', trigger: 'blur'}
        // ],
        allocation_num: [{
          required: true,
          message: "分配数量不能为0",
          trigger: "change"
        }],
        merchant_code: [{
          required: true,
          type: "array",
          message: this._vm.$t("devicelist.dailinotnull"),
          trigger: "change"
        }]
      },
      textData: null
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {},
    dids: {}
  },
  computed: {},
  methods: {
    handleUpload: function handleUpload(file) {
      console.log("filefile", file); //debugger

      if (file.name.indexOf(".xls") > -1 || file.name.indexOf(".xlsx") > -1) {
        this.$set(this.formModel, "filename", file);
      } else {
        // this.textData
        this.$Message.error(this._vm.$t("productModule.uploadPlaceHolderType"));
      }

      return false;
    },
    onCheckChange: function onCheckChange(curr, hVal) {
      console.log(curr, hVal);
      var data = [];

      for (var i in curr) {
        if (curr[i].area_name) {
          data.push(curr[i].area_code);
        }
      }

      this.$set(this.formModel, "area_codes", data);
      console.log(this.formModel.area_codes);
    },
    getAreaData: function getAreaData(callback) {
      var _this = this;

      this.areaData.splice(0);
      area_list({
        page: 1,
        page_size: 1000,
        parent_code: 1,
        all: 2,
        type: 1
      }).then(function (res) {
        if (res.result === 0) {
          //console.log(data)
          var data = res.body.list;

          _this.checkTree(data);

          _this.areaData = data;

          if (callback) {
            callback();
          }
        }
      });
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].area_name) {
          arr[i].value = arr[i].area_code;
          arr[i].label = arr[i].area_name;
          arr[i].title = arr[i].area_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    checkTree2: function checkTree2(arr) {
      for (var i in arr) {
        arr[i].value = arr[i].merchant_code;
        arr[i].label = arr[i].shop_name;

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree2(arr[i].children);
        }
      }
    },
    getMerchantData: function getMerchantData(callback) {
      var _this2 = this;

      this.merchantData.splice(0);
      get_merchant_all({}).then(function (res) {
        if (res.result === 0) {
          var data = res.body; //console.log("a",data)

          _this2.checkTree2(data);

          _this2.merchantData = data;

          if (callback) {
            callback();
          }
        }
      });
    },
    init: function init() {// project_list({page:0,page_size:15}).then(res=>{
      //   if(res.result===0){
      //     this.maintainList=res.body.list||[]
      //   }
      // })
    }
  },
  mounted: function mounted() {
    //debugger
    if (localStorage.getItem("country_code") == 'xciot-prod-cnsz') {
      this.country_code = "https://bms-api.xcthings.com";
    } else if (localStorage.getItem("country_code") == 'xciot-prod-hk') {
      this.country_code = "https://bms-hk-api.xcthings.com";
    } else if (localStorage.getItem("country_code") == 'xciot-prod-us2') {
      this.country_code = "https://bms-us-api.xcthings.com";
    } else if (localStorage.getItem("country_code") == 'xciot-prod-eu') {
      this.country_code = "https://bms-eu-api.xcthings.com";
    }

    console.log('this.country_code', this.country_code);

    if (this.projectCode) {
      this.$set(this.formModel, "project_code", this.projectCode);
    } //alert(123);
    //获取区域列表


    if (this.edit) {
      //  this.getAreaData()
      // this.getAreaData(()=>{
      //         let data=this.getAreaData(this.areaData,this.editData.area_code)
      //         console.log(data)
      //         this.$set(this.formModel,'area_code',data)
      //       })
      this.getMerchantData(function () {//  console.log("a", this.merchantData)
        //  console.log("b",this.setData.merchant_code)
      });

      if (this.setData) {
        //  console.log(this.setData)
        this.$set(this.formModel, "dids", [this.setData.did]);
      } else {
        this.$set(this.formModel, "dids", this.dids);
      }
    }
  },
  created: function created() {
    this.init();
  }
};